import { Injectable } from '@angular/core';
import { User } from '@spartacus/core';
import { UserAccountFacade } from 'src/feature-libs/kn-br-user/kn-br-account/root/facade/user-account.facade';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AtgFormLinksService {
  constructor(private userAccountFacade: UserAccountFacade) {}

  getUser(): Observable<User> {
    return this.userAccountFacade.get();
  }
}
